import React from 'react'
import { Widget } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { CountType } from 'enums'
import { getLabel } from 'utils/widgetTypeUtil'

import { PreSearchDataGuards, PostSearchDataGuards } from '../share/guards'
import RunSearchEffect from '../share/RunSearchEffect'
import DayAndHourChart from '../share/Charts'
import { DayAndHourWidgetsType } from '../types'
import useSelectedInsights from '../hooks'

import InsightModal from '../share/InsightModal'

const SocialWebDayAndHour: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<DayAndHourWidgetsType>(widgetId)

  const {
    selectedInsights,
    detailSetting,
    handleInsightsSelect,
    widgetSettingWithSelection,
    isModalOpen,
    setIsModalOpen
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <PreSearchDataGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <PostSearchDataGuards widgetId={widgetId}>
            <DayAndHourChart
              widgetId={widgetId}
              onInsightsSelect={handleInsightsSelect}
              heatmapKey={`heatmap-${isModalOpen}`}
            />
          </PostSearchDataGuards>
        </RunSearchEffect>
      </PreSearchDataGuards>
      <InsightModal
        widgetSettingWithSelection={widgetSettingWithSelection}
        open={isModalOpen}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={widgetSetting.countType || CountType.POSTS}
        selectedInsights={selectedInsights}
        onClose={() => {
          setIsModalOpen(false)
        }}
        detailSetting={detailSetting}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebDayAndHour
